import React, {Component} from 'react'
import {Route} from 'react-router-dom'
import UserProfile from '../../components/Profile/Profile'

export default class Profile extends Component {

  render() {
    return (
      <div className="animated fadeIn">
        <Route exact path="/profile" component={UserProfile}/>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/views/Profile/Profile.js